export const WIDGET_STATES = {
	DEFAULT: 'default',
	DETAIL: 'detail',
	MODAL: 'modal'
};
